import {apiFetch} from "../client";

// Денежная поверхность команды для админа (EXT-50): ручные ДДС-операции и
// обнуление. Появилась из инцидента 01.09.2026 — трейдеры вывели 3000 USDT
// напрямую из кабинета площадки, и записать это в наш леджер было нечем, кроме
// SQL на проде. Все суммы — десятичные строки, во float не переводятся.

export type TeamBalanceOperationType = "topup" | "withdrawal";

/**
 * Body of POST /v1/teams/{teamId}/balance/operations.
 *
 * `amount` is unsigned — the direction is `type`. `operationKey` is generated
 * once per operation (not per attempt) so a retry after a network failure
 * replays the original instead of moving the balance twice. `merchantId` is the
 * optional counterparty: the team balance is read in per-merchant slices, and a
 * correction about a cabinet's money must land in that cabinet's slice.
 */
export interface TeamBalanceOperationRequest {
    type: TeamBalanceOperationType;
    amount: string;
    operationKey: string;
    merchantId?: string;
}

export interface TeamBalanceOperationResponse {
    operation: {
        id: string;
        type: TeamBalanceOperationType;
        amount: string;
        occurredAt: string;
    };
    /** Team balance right after the operation, as a USDT string. */
    balance: string;
    currency: string;
}

/** POST /v1/teams/{teamId}/balance/operations — admin-entered top-up or withdrawal. */
export function applyTeamBalanceOperation(
    token: string | null,
    teamId: string,
    body: TeamBalanceOperationRequest,
): Promise<TeamBalanceOperationResponse> {
    return apiFetch<TeamBalanceOperationResponse>(
        `/teams/${encodeURIComponent(teamId)}/balance/operations`,
        token,
        {method: "POST", body: JSON.stringify(body)},
    );
}

/** Response of the admin team reset endpoint — team.BalanceResponse of the backend. */
export interface TeamBalanceResetResponse {
    id: string;
    currency: string;
    amount: string;
    withdrawable: string;
    lastBalanceResetDate: string;
}

/** POST /v1/teams/{teamId}/balance/reset — обнуление баланса команды админом. */
export function resetTeamBalanceAsAdmin(token: string | null, teamId: string): Promise<TeamBalanceResetResponse> {
    return apiFetch<TeamBalanceResetResponse>(
        `/teams/${encodeURIComponent(teamId)}/balance/reset`,
        token,
        {method: "POST"},
    );
}
